/**
 * Shadow Design Tokens
 *
 * Shadow definitions for elevation system (1-24 levels).
 * These match MUI's elevation scale and are used for paper surfaces,
 * floating elements, and interactive states.
 */

export const shadows = Object.freeze({
  elevation1:
    '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
  elevation2:
    '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)',
  elevation3:
    '0px 1px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px -2px rgba(0, 0, 0, 0.20)',
  elevation4:
    '0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.20)',
  elevation5:
    '0px 1px 14px 0px rgba(0, 0, 0, 0.12), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)',
  elevation6:
    '0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)',
  elevation7:
    '0px 2px 16px 1px rgba(0, 0, 0, 0.12), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 4px 5px -2px rgba(0, 0, 0, 0.20)',
  elevation8:
    '0px 3px 14px 2px rgba(15, 15, 16, 0.12), 0px 8px 10px 1px rgba(15, 15, 16, 0.14), 0px 5px 5px -3px rgba(15, 15, 16, 0.20)',
  elevation9:
    '0px 3px 16px 2px rgba(0, 0, 0, 0.12), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 5px 6px -3px rgba(0, 0, 0, 0.20)',
  elevation10:
    '0px 4px 18px 3px rgba(0, 0, 0, 0.12), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 6px 6px -3px rgba(0, 0, 0, 0.20)',
  elevation11:
    '0px 4px 20px 3px rgba(0, 0, 0, 0.12), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 6px 7px -4px rgba(0, 0, 0, 0.20)',
  elevation12:
    '0px 5px 22px 4px rgba(0, 0, 0, 0.12), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 7px 8px -4px rgba(0, 0, 0, 0.20)',
  elevation13:
    '0px 5px 24px 4px rgba(0, 0, 0, 0.12), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 7px 8px -4px rgba(0, 0, 0, 0.20)',
  elevation14:
    '0px 5px 26px 4px rgba(0, 0, 0, 0.12), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 7px 9px -4px rgba(0, 0, 0, 0.20)',
  elevation15:
    '0px 6px 28px 5px rgba(0, 0, 0, 0.12), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 8px 9px -5px rgba(0, 0, 0, 0.20)',
  elevation16:
    '0px 6px 30px 5px rgba(0, 0, 0, 0.12), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 8px 10px -5px rgba(0, 0, 0, 0.20)',
  elevation17:
    '0px 6px 32px 5px rgba(0, 0, 0, 0.12), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 8px 11px -5px rgba(0, 0, 0, 0.20)',
  elevation18:
    '0px 7px 34px 6px rgba(0, 0, 0, 0.12), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 9px 11px -5px rgba(0, 0, 0, 0.20)',
  elevation19:
    '0px 7px 36px 6px rgba(0, 0, 0, 0.12), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 9px 12px -6px rgba(0, 0, 0, 0.20)',
  elevation20:
    '0px 8px 38px 7px rgba(0, 0, 0, 0.12), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 10px 13px -6px rgba(0, 0, 0, 0.20)',
  elevation21:
    '0px 8px 40px 7px rgba(0, 0, 0, 0.12), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 10px 13px -6px rgba(0, 0, 0, 0.20)',
  elevation22:
    '0px 8px 42px 7px rgba(0, 0, 0, 0.12), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 10px 14px -6px rgba(0, 0, 0, 0.20)',
  elevation23:
    '0px 9px 44px 8px rgba(0, 0, 0, 0.12), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 11px 14px -7px rgba(0, 0, 0, 0.20)',
  elevation24:
    '0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)',
})

// Additional shadow tokens
export const dropShadows = {
  chips: '0px 2px 4px rgba(0, 0, 0, 0.30)',
  cardOutline: '0 1.5px 0 0.5px rgba(224, 224, 224, 0.5)',
  cardPreview: '0 1.5px 0 0 var(--palette-primary-main, #AAFBB2)',
  drawer: '-40px 0 80px 0 rgba(0, 0, 0, 0.75)',
} as const

export const playingCardShadows = {
  tight: '0px 4.457px 4.457px rgba(0,0,0,0.25)',
  loose: '0px 3.247px 6.494px rgba(0,0,0,0.25)',
  highlighted: '0 4px 24px var(--palette-primary-main, #AAFBB2)',
  // Card overlap shadows for revealed cards on the table left/right direction
  // https://www.figma.com/design/s5knlq42XjwZx88JuPw8c7/GTOW-Design-System?node-id=8730-261323&m=dev
  overlapRight: '1px 0 4px 1px rgba(9, 9, 12, 0.40)',
  overlapLeft: '-1px 0 4px 1px rgba(9, 9, 12, 0.40)',
} as const

export const pokerTableShadows = {
  // The rail's drop onto the page.
  rail: '0px 12px 32px rgba(0, 0, 0, 0.55), 0px 2px 6px rgba(0, 0, 0, 0.5)',
  // The felt darkening under the rail. A shadow, not a line: the table draws no edge of its
  // own beyond the rail's two.
  felt: 'inset 0px 0px 24px 6px rgba(0, 0, 0, 0.55)',
} as const

// Consolidated export
export const allShadows = {
  ...shadows,
  drop: dropShadows,
} as const
